/**
 * Created by kldavis on 9/9/16.
 */

function getCookie(name) {
    var re = new RegExp(name + "=([^;]+)");
    var value = re.exec(document.cookie);
    return (value !== null) ? unescape(value[1]) : null;
}

function checkFMActive (fm, setFm) {
    var selectedText = '';
    if (fm == setFm) {
        selectedText = 'selected';
    }
    return selectedText;
}

$(document).ready(function () {
    var STID_default = 'STIL';

    try {
        var STID_default = getCookie('stid').toUpperCase();
    }
    catch (e) {
        STID_default = 'STIL';
    }

    var mainSiteName = $('.mainSiteName').val();

    var model_names = {
        'A': 'A - Western annual grasses / annual cropland / urban',
        'B': 'B - Tall dense evergreen brush / eastern redcedar',
        'F': 'F - Intermediate evergreen brush',
        'G': 'G - Forest with heavy downed fuels',
        'K': 'K - Light slash',
        'L': 'L - Western perennial grasses',
        'P': 'P - Southern pine forest',
        'R': 'R - Hardwood forest',
        'T': 'T - Tallgrass with open evergreen brush'
    };

    // get default and current fuel models
    var defaultFM = $('#default_fm').val();
    var fmText = 'fm_'+STID_default.toLowerCase();
    var altFMNumber = getCookie(fmText);
    var altFM = altFMNumber === null ? null : altFMNumber;
    var altFMText = altFMNumber === null ? null : model_names[altFMNumber];
    var currentFM = altFM === null ? defaultFM : altFM;

    // set up drop down for fuel model with selected option
    var fuelModelDropDown = '' +
        '<select name="fuel_model" id="fuel_model">' +
        '<option value="A" '+checkFMActive("A",currentFM)+'>A - Western annual grasses / annual cropland / urban</option>' +
        '<option value="B" '+checkFMActive("B",currentFM)+'>B - Tall dense evergreen brush / eastern redcedar</option>' +
        '<option value="F" '+checkFMActive("F",currentFM)+'>F - Intermediate evergreen brush</option>' +
        '<option value="G" '+checkFMActive("G",currentFM)+'>G - Forest with heavy downed fuels</option>' +
        '<option value="K" '+checkFMActive("K",currentFM)+'>K - Light slash</option>' +
        '<option value="L" '+checkFMActive("L",currentFM)+'>L - Western perennial grasses</option>' +
        '<option value="P" '+checkFMActive("P",currentFM)+'>P - Southern pine forest</option>' +
        '<option value="R" '+checkFMActive("R",currentFM)+'>R - Hardwood forest</option>' +
        '<option value="T" '+checkFMActive("T",currentFM)+'>T - Tallgrass with open evergreen brush</option>' +
        '</select>';

    // set up default model text
    var defaultText = 'Default is '+defaultFM;

    // set up warning message if using a different fuel model
    var default_warning = '';
    if (defaultFM != currentFM) {
        default_warning = '<div style="background-color: #f89448;"><span style="color: white;">Using Alternative Fuel Model!</span></div>';
    }

    // add all of the fuel model content to the sidebar.
    if (!window.location.pathname.startsWith('/index.php/okfire/current_station_conditions')) {
        $('#products_menu').append('<div class="fmDiv">Current Fuel Model for<br/>'+mainSiteName+'<br/>'+fuelModelDropDown+'<br/><i>'+defaultText+'</i><br/>'+default_warning+'<br/><a class="changeFM" href="/index.php/okfire/fuel_model_options">Station Fuel Model Options</a></div>');
    }
    //additional links for sidebar
    var lat = $('.mainSiteLat').val();
    var lon = $('.mainSiteLon').val();

    // Reverting to old style of link for forecast data. -KDJ 5/30/18 www/www-mesonet-org#130
    var NWSLinks = '<a href="https://forecast.weather.gov/MapClick.php?lat='+lat+'&lon='+lon+'&FcstType=graphical" target="product">NWS Forecast Chart ('+mainSiteName+')</a> </div>' +
         '<a href="https://forecast.weather.gov/MapClick.php?lat='+lat+'&lon='+lon+'&FcstType=digital" target="product">NWS Forecast Table ('+mainSiteName+')</a> </div>';

    // Commenting this out for now.
    //var NWSLinks = '<a href="https://forecast-v3.weather.gov/point/'+lat+','+lon+'/charts?tab=hwg" target="product">NWS Forecast Chart ('+mainSiteName+')</a> </div>' +
    //               '<a href="https://forecast-v3.weather.gov/point/'+lat+','+lon+'/charts?tab=tabular" target="product">NWS Forecast Table ('+mainSiteName+')</a> </div>';

    $("#products_menu a:contains('Fire Prescription Planner')").parent().after(NWSLinks);

    // add US lightning map link
    $("#products_menu a:contains('Oklahoma Burn Bans')").parent().before('<a target="product" href="https://weather.us/lightning/oklahoma">Recent Lightning Activity</a>');

    // if fuel model is changed, set cookie and reload.
    $('#fuel_model').on('change', function() {
        var fmVal = $(this).val();
        var fm_stid = 'fm_'+STID_default.toLowerCase();

        if (fmVal != defaultFM) {
            $.cookie(fm_stid, fmVal, {domain: get_cookie_domain(), path: '/', expires: new Date().getTime() + 31536000});
        } else {
            $.cookie(fm_stid, fmVal, {domain: get_cookie_domain(), path: '/', expires: new Date().getTime() - 3600});
        }

        location.reload();
    });
});
